import { bus, EVENTS } from '@/services/bus'
import Vue from 'vue'
import Router from 'vue-router'
import jwtDecode from 'jwt-decode'

import AdvRouter from './advRouter'
import AppHome from '@/components/home/AppHome'
import AppLogin from '@/components/login/AppLogin'
import AccessRouter from './accessRouter'
import CalendarRouter from './calendarRouter'
import CompanyRouter from './companyRouter'
import ContactRouter from './contactRouter'
import DenunciationRouter from './denunciationRouter'
import EventRouter from './eventRouter'
import ExternalAccessRouter from './externalAccessRouter'
import FluxRouter from './fluxRouter'
import Forbidden from '@/components/utils/Forbidden'
import GroupRouter from './groupRouter'
import LotRouter from './lotRouter'
import NotFound from '@/components/layout/404'
import OptionRouter from './optionRouter'
import OriginRouter from './originRouter'
import PoleRouter from './poleRouter'
import ProgramRouter from './programRouter'
import PromoteurRouter from './promoteurRouter'
import ResetPassword from '@/components/login/ResetPassword'
import SearchVue from '@/components/search/SearchVue'
import StatisticRouter from './statisticRouter'
import UsersRouter from './userRouter'
import StockRouter from './stockRouter'
import UserStatsVue from '@/components/debug/UserStatsVue'
import LeadRouter from './leadRouter'
import ParkingRouter from './parkingRouter'

import redirectBuilder from '@batimentb/okimmo-redirect'

import store from '../services/store'

const Redirect = redirectBuilder(require('../../config/runtimeConf/redirectConfig'))

Vue.use(Router)

const router = new Router({
  // mode: 'history', // Desactivé car conflit avec netlify et redirections
  linkActiveClass: 'is-active',
  scrollBehavior (to, from, savedPosition) {
    store.commit('setScrollEl', null)
    store.commit('setScrollPage', null)
    if (to.name !== from.name && from.query.returnId && from.query.page) {
      store.commit('setScrollEl', from.query.returnId)
      store.commit('setScrollPage', from.query.page)
    } else if (to.name !== from.name && from.query.returnId) {
      store.commit('setScrollEl', from.query.returnId)
    } else if (savedPosition) {
      return savedPosition
    } else {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({x: 0, y: 0})
        }, 200)
      })
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: AppHome,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: AppLogin
    },
    {
      path: '/resetpassword',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Forbidden
    },
    {
      path: '/redirect',
      name: 'Redirect',
      component: Redirect
    },
    {
      path: '/search',
      name: 'SearchVue',
      component: SearchVue,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/debug/stats',
      name: 'UserStatsVue',
      component: UserStatsVue,
      meta: {
        requiresAuth: true,
        needProfile: ['admin']
      }
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound
    },
    // REDIRECTION HANDLER
    {
      path: '/redirect',
      name: 'redirect',
      component: Redirect,
      meta: {requiresAuth: true, title: 'Redirection'}
    },
    ...AdvRouter,
    ...StatisticRouter,
    ...OriginRouter,
    ...PromoteurRouter,
    ...CompanyRouter,
    ...UsersRouter,
    ...GroupRouter,
    ...ProgramRouter,
    ...LotRouter,
    ...ContactRouter,
    ...AccessRouter,
    ...EventRouter,
    ...FluxRouter,
    ...OptionRouter,
    ...DenunciationRouter,
    ...ExternalAccessRouter,
    ...PoleRouter,
    ...CalendarRouter,
    ...StockRouter,
    ...LeadRouter,
    ...ParkingRouter
  ]
})

function jwtExpired (decoded) {
  let expired = false
  if (!decoded) expired = true
  else expired = decoded.exp < Date.now() / 1000
  return expired
}

router.beforeEach((to, from, next) => {
  // console.log(to)
  const needAuth = to.meta.requiresAuth
  const needProfile = to.meta.needProfile
  const token = localStorage.getItem('token')
  let decoded = null

  if (from.name !== to.name && to.meta.parentName !== 'StockVue') {
    document.querySelector('body').classList.remove('has-contentmain-fullscreen')
    if (document.querySelector('.l-header')) {
      document.querySelector('.l-header').style.zIndex = '36'
      document.querySelector('.l-navigationmain').style.zIndex = '37'
    }
  }

  if (!to.matched.length) next('/404')

  if (token) decoded = jwtDecode(token)

  bus.$emit(EVENTS.ROUTEUPDATE)
  bus.$emit(EVENTS.CLOSE_SEARCH_PANEL)
  store.commit('setQuickview', {})
  bus.$emit(EVENTS.CLEAN_SEARCH_INPUT)

  if (!needAuth) return next()
  else if (needAuth && jwtExpired(decoded)) {
    bus.$emit(EVENTS.LOGOUT)
    localStorage.setItem('redirectAfterLogin', to.path)
    return next({path: '/login'})
  } else if (needAuth && needProfile && (!decoded || !needProfile.includes(decoded.profil_type))) {
    return next({name: 'Forbidden'})
  }

  if (token) {
    Vue.$api.setToken(token)
  }

  next()
})

router.goBack = (route) => {
  if (window.history.length > 1) {
    return router.go(-1)
  } else {
    if (route && route.params && route.params.id) {
      return router.push({name: route.meta.parentName, params: {id: route.params.id}})
    } else {
      return router.push({name: route.meta.parentName})
    }
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js